import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import ProjectUpdateComponent, { ProjectUpdateComponentProps } from './ProjectUpdate.component';
import Project from 'src/entities/Project';
import { getProject, GetProjectAction, GetProjectSuccess } from 'src/actions/project/get/GetProject.actions';
import * as getProjectTypes from 'src/actions/project/get/Types';
import { match } from 'react-router';
import {
  indexSectorsOfInterest,
  IndexSectorsOfInterestAction
} from 'src/actions/sector-of-interest/index/IndexSectorsOfInterest.actions';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import { changeProjectData, ChangeProjectDataAction } from 'src/actions/project/change-data/ChangeProjectData.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

interface StateProps {
  project?: Project;
  error: boolean;
  errorMessage: {};
  sectorsOfInterest: SectorOfInterest[];
}

interface DispatchProps {
  getProject(projectId: number): Promise<GetProjectAction>;

  changeProjectData(project: Project): ChangeProjectDataAction;

  indexSectorsOfInterest(): Promise<IndexSectorsOfInterestAction>;
}

interface OwnProps {
  match: match<{ projectId: number }>;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

interface State {
  projectSection: string;
  success?: boolean;
  logo?: File;
}

class ProjectUpdateContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      projectSection: 'contact'
    };
  }

  public componentWillMount(): void {
    this.props.indexSectorsOfInterest();
    this.props.getProject(this.props.match.params.projectId).then((response: GetProjectSuccess) => {
      if (response.type === getProjectTypes.GET_PROJECT_SUCCESS) {
        this.props.changeProjectData(this.props.project!);
      }
    });
    this.setState(
      {success: false}
    );
  }

  public render(): React.ReactNode {
    return (
      this.props.project ?
        <ProjectUpdateComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private handleClick(value: string): void {
    this.setState({projectSection: value});
  }

  private handleSubmit(): void {
    /*this.props.updatePhysicalPerson(this.props.formData!).then((response: UpdatePhysicalPersonSuccess) => {
      if (response.type === updatePhysicalPersonTypes.UPDATE_PHYSICAL_PERSON_SUCCESS) {
        this.setState(
          {success: true}
        );
      }
    });*/

    // updateCompany && updateProject
  }

  private getComponentProps(): ProjectUpdateComponentProps {
    return {
      handleSubmit: () => this.handleSubmit(),
      handleClick: (value: string) => this.handleClick(value),
      projectSection: this.state.projectSection,
      project: this.props.project!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getProject: (projectId: number): Promise<GetProjectAction> => (
    dispatch(getProject(projectId))
  ),
  indexSectorsOfInterest: (): Promise<IndexSectorsOfInterestAction> => (
    dispatch(indexSectorsOfInterest())
  ),
  changeProjectData: (project: Project): ChangeProjectDataAction => (
    dispatch(changeProjectData(project))
  ),
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  project: state.getProject.project,
  error: state.getProject.error,
  errorMessage: state.getProject.errorMessage,
  sectorsOfInterest: state.indexSectorOfInterest.sectorsOfInterest,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectUpdateContainer);



// WEBPACK FOOTER //
// ./src/modules/project/update/ProjectUpdate.container.tsx